import {
  ArrowRight,
  CalendarDays,
  Download,
  Headphones,
  ListChecks,
  MessageSquareText,
  Phone,
  Sparkles,
} from "lucide-react";
import "../connected-suite-bridge.css";

const suiteProducts = [
  {
    name: "Connect",
    copy: "Communication",
    Icon: MessageSquareText,
    className: "csb-product--connect",
  },
  {
    name: "Desk",
    copy: "Workflow Management",
    Icon: ListChecks,
    className: "csb-product--desk",
  },
  {
    name: "Assist",
    copy: "Remote Support",
    Icon: Headphones,
    className: "csb-product--assist",
  },
];

export default function ConnectedSuiteBridge() {
  return (
    <section
      id="connected-suite"
      className="csb-section"
      aria-label="Cullath connected products"
    >
      <div className="csb-container">
        <div className="csb-shell">
          <div className="csb-grid" aria-hidden="true" />
          <div
            className="csb-glow csb-glow--one"
            aria-hidden="true"
          />
          <div
            className="csb-glow csb-glow--two"
            aria-hidden="true"
          />

          <span
            className="csb-orbit csb-orbit--one"
            aria-hidden="true"
          />

          <span
            className="csb-orbit csb-orbit--two"
            aria-hidden="true"
          />

          <div className="csb-intro">
            <span className="csb-kicker">
              <Sparkles size={14} />
              WHERE WORK ORBITS.
            </span>

            <strong>One connected platform.</strong>

            <small>
              Move from conversation to workflow to support without
              leaving the same workspace.
            </small>
          </div>

          <div className="csb-track-wrap">
            <div className="csb-track">
              <span
                className="csb-energy-line"
                aria-hidden="true"
              >
                <i />
                <i />
                <i />
              </span>

              {suiteProducts.map(
                ({ name, copy, Icon, className }, index) => (
                  <div
                    className={`csb-product ${className}`}
                    key={name}
                  >
                    <span className="csb-product-index">
                      0{index + 1}
                    </span>

                    <span className="csb-icon">
                      <Icon size={22} />
                    </span>

                    <span className="csb-copy">
                      <strong>{name}</strong>
                      <small>{copy}</small>
                    </span>

                    <ArrowRight
                      className="csb-product-arrow"
                      size={16}
                      aria-hidden="true"
                    />
                  </div>
                )
              )}
            </div>

            <span className="csb-platform-caption">
              <i />
              One Connected Platform
              <i />
            </span>
          </div>

          <div className="csb-actions">
            <a className="csb-demo" href="/contact-us">
              <CalendarDays size={16} />
              <span>Request a Demo</span>
              <ArrowRight size={15} />
            </a>

            <div className="csb-action-row">
              <a href="/contact-us">
                <Phone size={15} />
                Contact Us
              </a>

              <a href="https://connect.cullath.com/desktop/Cullath.exe">
                <Download size={15} />
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}